<template>
  <div class="certification-updates-header-wrapper">
    <span class="header">Certification Updates</span>
    <OpalPill
      v-show="certificationCount > 0 && status"
      :content="status"
      class="inline-pill pill-gray"
    />
  </div>
  <loader v-if="showLoader" />
  <div class="certification-updates-content" v-else>
    <div class="description"><slot name="description"></slot></div>
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
import OpalPill from "@/components/shared/OpalPill.vue";
import Loader from "@/components/shared/Loader.vue";

const props = withDefaults(
  defineProps<{
    certificationCount: number;
    status?: string;
    showLoader?: boolean;
    error?: boolean;
    loaded: boolean;
  }>(),
  {
    error: false,
    showLoader: true,
    loaded: false,
  },
);
</script>

<style scoped src="@/styles/certification-updates/base.css"></style>

<style scoped>
.certification-updates-header-wrapper {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.certification-updates-header-wrapper .header {
  line-height: 22px;
  font-weight: 700;
  font-size: 1.25rem;
}

.description {
  margin-top: 6px;
}

/* Targets screens between 992px and 1210px inclusive, OR smaller than 568px */
@media (992px <= width <= 1210px) or (width < 568px) {
  .certification-updates-header-wrapper {
    flex-direction: column;
    align-items: start;
  }

  .description {
    margin-top: 8px;
  }
  .certification-updates-header-wrapper .header {
    margin-bottom: 8px;
  }
}

</style>
